import React from 'react';
import { LegendItem } from './LegendItem';
import { LegendContainer } from './style';
import colors from 'constants/colors';

const Legend = ({remaining = 0, redeemed = 0}) => {
  return (
    <LegendContainer>
      <div className='rowLabel'>Voucher Summary</div>
      <div className='legends'>
        <LegendItem
          backgroundColor={colors.lightGreen}
          legendTitle={remaining + " Remaining"}
        />
        <LegendItem
          backgroundColor={colors.blue}
          legendTitle={redeemed + " Redeemed"}
        />
      </div>
    </LegendContainer>
  );
};

export default Legend;
